import { Dict } from 'app/types/decorable';
import { EventEmitter } from '@angular/core';
import { DictHandler, SimpleHandler } from 'app/types/handlers';
import { v4 as uuid } from 'uuid';
export class InterruptableTimer {
  private args: Dict | null = null;
  private msecondsPerSample: number;
  private handler: SimpleHandler | DictHandler | null = null;
  private timerMSeconds?: number;
  private sampling: boolean;
  private lastInterrupt = 0;
  private lastInterruptId: any;
  private targetTime:Date = new Date();
  public wasRunning = false;
  public samples = new EventEmitter<any>();
  constructor(optMsecondsPerSample: number = 2500) {
    this.msecondsPerSample = optMsecondsPerSample;
    this.sampling = false;
  }
  get isSampling(): boolean {
    return this.sampling;
  }

  Start(handler: DictHandler | SimpleHandler, optTimerMSeconds: number = NaN, optArgs: Dict | null = null) {
    if (this.lastInterrupt !== 0) {
      if (optArgs !== null) {
        this.args = optArgs;
      }
      this.Interrupt(false);
      return;
    }
    this.wasRunning = false;
    this.handler = handler;

    this.timerMSeconds = isNaN(optTimerMSeconds) ? this.msecondsPerSample : optTimerMSeconds;
    this.msecondsPerSample = Math.min(this.timerMSeconds, this.msecondsPerSample);
    this.args = optArgs;
    this.Interrupt();
  }
  Stop(optTriggerHandler: boolean = false) {
    this.lastInterrupt = 0;
    this.wasRunning = true;
    if (optTriggerHandler === true) {
      if (this.handler) {
        const args = !!this.args ? this.args : {};
        this.handler(args);
      }
    }
  }
  Cancel() {
    this.Stop(false);
    this.handler = () => { };
  }
  Interrupt(isNew: boolean = true) {
    if (isNew === true) {
      this.lastInterrupt = Date.now().valueOf();
      this.lastInterruptId = uuid();
    }

    setTimeout(() => {

      if (this.lastInterrupt === 0) {
        return;
      }
      const id = this.lastInterruptId;
      if (!this.timerMSeconds && (this.timerMSeconds !== 0)) {
        this.timerMSeconds = 0;
      }
      if ((Date.now().valueOf() - this.lastInterrupt) < this.timerMSeconds) {
        this.Interrupt(false);
        return;
      }
      window.requestAnimationFrame(() => {
        if (!!this.handler && (id === this.lastInterruptId)) {
          const args = !!this.args ? this.args : {};
          this.handler(args);
        }

      });
      this.lastInterrupt = 0;


    }, 10);
  }
}
